import { useEffect } from 'react';
import { clinicSchema, websiteSchema, dentistPersonSchema } from '../lib/schema';
import { DOCTORS } from '../data/doctors';

const SCRIPT_ID = 'clinic-graph-jsonld';
const noCtx = ({ '@context': _c, ...rest }) => rest;

export default function ClinicSchema() {
    useEffect(() => {
        if (document.getElementById(SCRIPT_ID)) return;
        const graph = [clinicSchema, websiteSchema, ...DOCTORS.map(dentistPersonSchema)].map(noCtx);
        const s = document.createElement('script');
        s.type = 'application/ld+json';
        s.id = SCRIPT_ID;
        s.textContent = JSON.stringify({ '@context': 'https://schema.org', '@graph': graph });
        document.head.appendChild(s);
    }, []);
    return null;
}
